import React, { Component } from 'react'
import { connect } from 'react-redux'

// Components
import Loader from '../../utils/Loader'
import BannerNew from './BannerNew'
import BannerItem from './BannerItem'

// State
import { addRoute } from '../../../store/actions/route'
import { setpageTitle } from '../../../store/actions/siteInfo'
import { getBanners } from '../../../store/actions/banners'

import '../../../css/image-uploader.css'

class AdminBanners extends Component {
    constructor(props){
        super(props)
        this.props.addRoute(this.props.match)
        this.props.setpageTitle('Banners')
    }

    componentDidMount(){
        if(!this.props.banners.length){
            this.props.getBanners()
        }
    }

    render() {
        return (
            <div>
                <h1>Banners</h1>

                <BannerNew />

                {this.props.isLoading ? (
                    <Loader />
                ) : (
                    this.props.loadError ? (
                        <div className="error msg_animate">{this.props.loadError}</div>
                    ) : (
                        this.props.banners.length ? (
                            this.props.banners.map(banner =>
                                <BannerItem key={banner.id} banner={banner} />
                            )
                        ) : (
                            <div>There are no banners</div>
                        )
                    )
                )}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        banners: !!state.banners.banners ? state.banners.banners : [],
        isLoading: state.banners.isLoading,
        loadError: state.banners.error
    }
}

export default connect(mapStateToProps, { addRoute, setpageTitle, getBanners })(AdminBanners)



// WEBPACK FOOTER //
// ./src/components/admin/banners/AdminBanners.js